<template>
  <div class='inputLoginAdm'>
    <div class="cont-icon">
      <component :is="icon"/>
    </div>
    <input @input="e => $emit('returnValue', e.target.value)" :type="type">
  </div>
</template>

<script>
import userIcon from './icons/userIcon'
import passIcon from './icons/passIcon'
export default {
  name: 'inputLoginAdm',
  components: { userIcon, passIcon },
  props: {
    icon: {
      type: String,
      default: 'userIcon'
    },
    type: {
      type: String,
      default: 'text'
    }
  }
}
</script>

<style scoped>
.inputLoginAdm {
  border: thin solid #CCCCCC;
  border-radius: 5px;
  width: 70%;
  margin: auto;
  display: flex;
  overflow: hidden;
  margin-bottom: 6%;
}
.cont-icon {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
input {
  width: 75%;
  border: 0;
  padding: 4%;
  background-color: #EEEEEE;
}
input:focus {
  outline: none;
}
</style>
